/* eslint-disable default-param-last */
import { LIST_REQUEST, LIST_SUCCESS, LIST_FAIL, LIST_RESET } from '../types/users';
import { FOLLOW_TOGGLE_SUCCESS } from '../types/game';
import { LOGOUT } from '../types/auth';

export const usersReducer = (state = { USERLIST: [] }, action) => {
  switch (action.type) {
    case LIST_REQUEST:
      return {
        loading: true,
        USERLIST: [],
      };

    case LIST_SUCCESS:
      return {
        loading: false,
        success: true,
        USERLIST: action.payload,
      };

    case LIST_FAIL:
      return {
        loading: false,
        error: action.payload,
        USERLIST: [],
      };

    case LIST_RESET:
    case LOGOUT:
      return {
        USERLIST: [],
      };

    case FOLLOW_TOGGLE_SUCCESS:
      return {
        ...state,
        USERLIST: state.USERLIST.map((u) =>
          u.username === action.payload.username
            ? { ...u, is_following: action.payload.following }
            : u
        ),
      };

    default:
      return state;
  }
};
